// extracted by mini-css-extract-plugin
export var bubble = "_12-0";
export var container = "_12-3";
export var contrastBorder = "_12-4";
export var greyOut = "_12-2";
export var initialsWrapper = "_12-1";
export var large = "_12-9";
export var medium = "_12-8";
export var mediumSmall = "_12-7";
export var mediumSmallMedium = "_12-c";
export var micro = "_12-5";
export var small = "_12-6";
export var tiny = "_12-b";
export var xTiny = "_12-a";